import { TYPE_Chip } from '../hooks'

/**
 * 把 meta 里的碎片信息转换成 Chip 组件能直接用的
 *
 * @param {TYPE_Chip} chip 碎片信息
 *
 * */
export const formatChip = (chip: TYPE_Chip) => {
    const { id, type, uuid, title } = chip

    return {
        id,
        name: `${type}_${id}_${uuid}`,
        type,
        title,
        groupName: title
    }
}
